<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-15 10:03:08
 * @LastEditTime : 2023-09-26 09:24:53
 * @LastEditors  : yangxr
 * @Description  : 查看照片
 * @FilePath     : \icps_change\src\components\File\lookPicture.vue
-->
<template>
  <el-dialog :visible="visible" width="740px" :close-on-click-modal="false" :modal-append-to-body="true" @close="onClose">
    <span slot="title" class="dialog-title">图片预览</span>
    <div class="dialoginfo">
      <div class="FZYimgMp4list">
        <div v-for="(v, k) in urlList" :key="k">
          <el-image :src="'/file/' + v" :preview-src-list="srcList" style="width: 200px; height: 200px; margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)" :z-index="10000" @click="srcList = ['/file/' + v]"></el-image>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="onClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name:"lookPicture",
  data() {
    return {
      srcList: [],
    };
  },
  props: {
    visible: {
      type: Boolean,
    },
    urlList:  {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss">
.FZYimgMp4list {
  display: flex;
  flex-wrap: wrap;
}
</style>